import type { RedirectListParams } from '../api/redirects-api';

/** Store-scoped keys; page, post and category renames invalidate `all`. */
export const redirectKeys = {
  all: (storeId: string) => ['stores', storeId, 'redirects'] as const,
  list: (storeId: string, params: RedirectListParams) =>
    [...redirectKeys.all(storeId), 'list', params] as const,
};
